import { GridColumnVisibilityModel } from '@microservices/wiskey-react-table-component'

import { ConfiguredColumn, RestrictionData } from '@types'

import { getColumnFieldName } from './getColumnFieldName'
import { isColumnPinnedByAdmin } from './isColumnPinnedByAdmin'

export const applyAdminPinnedColumnVisibility = (
  model: GridColumnVisibilityModel,
  viewColumns: ConfiguredColumn[],
  defaultEntityRestrictions?: RestrictionData
): GridColumnVisibilityModel => {
  const nextModel = { ...model }

  viewColumns.forEach(column => {
    if (isColumnPinnedByAdmin(column.code, defaultEntityRestrictions)) {
      nextModel[getColumnFieldName(column)] = true
    }
  })

  return nextModel
}
